<template>
  <div class="base-container bg-default">
    <div class="white" style="padding-bottom: 130px">
      <v-container>
        <v-row justify="center">
          <v-img src="@/assets/img-finalizado.png" max-width="200" />
          <v-col cols="12">
            <h4 class="secondary-font text-center">Obrigado por preencher!</h4>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-row no-gutters justify="center" style="margin-top: -120px">
      <v-col cols="10" sm="6" md="4">
        <AgendamentoCard :ficha-preenchida="false" v-bind="agendamento" disable-actions />
      </v-col>
    </v-row>
    <v-row no-gutters justify="center" align="center" class="my-10">
      <v-btn
        @click="onFinalizar"
        color="warning"
        class="secondary-font text-capitalize font-weight-black"
        outlined
        rounded
        >meus Agendamentos
        <v-spacer></v-spacer>
      </v-btn>
    </v-row>
    <RedirectAssinaturaDialog v-if="showRedirectAssinaturaDialog" v-model="showRedirectAssinaturaDialog" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import RedirectAssinaturaDialog from '@/modules/Agendamento/dialogs/RedirectAssinaturaDialog'
const AgendamentoCard = () => import('@/modules/Agendamento/AgendamentoCard')

export default {
  components: {
    AgendamentoCard,
    RedirectAssinaturaDialog
  },
  data() {
    return {
      assinatura: null,
      showRedirectAssinaturaDialog: false,
      loading: false
    }
  },
  computed: {
    ...mapState('fichaClinica', ['agendamento'])
  },
  methods: {
    onFinalizar() {
      this.$store.commit('fichaClinica/RESET')
      this.$router.push({ name: 'agendamentos' })
    },
    openRedirectModal() {
      this.showRedirectAssinaturaDialog = true
    }
  }
}
</script>
